import {
  createWebHashHistory,
  createRouter,
  RouteRecordRaw,
  RouteLocationNormalized,
  NavigationGuardNext,
} from "vue-router"
import SessaoServico from "@/servicos/sessao.service"

import { atividadesRota } from "./modulos/atividades"
import { profissionaisRotas } from "./modulos/profissionais"
import { projetosRotas } from "./modulos/projetos"
import { usuariosRotas } from "./modulos/usuarios"
import { autenticacaoRotas } from "./modulos/auth"
import { estatisticasRotas } from "./modulos/estatisticas"
import { ImportacoesRotas } from "./modulos/importacoes"

import { mapGuards } from "@/router/guardas"
import { usarPermissionamento } from "@/composable/UsarPermissionamento"
import { NomeModuloTimesheet } from "@/composable/UsarPermissionamento/usarPermissionamento"

import { OperacaoDePermissionamento } from "@/composable/UsarPermissionamento/modulosDePermissao"
import { OperadorLogico } from "@/types/gerais"

/* eslint-disable */
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/atividades",
  },
  ...autenticacaoRotas(),
  ...atividadesRota(),
  ...profissionaisRotas(),
  ...projetosRotas(),
  ...usuariosRotas(),
  ...estatisticasRotas(),
  ...ImportacoesRotas(),
]

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_FRONTEND_BASE_URL_HASH),
  routes,
})

type RegraDeRotasTimesheet = "auth" | "livre" | "cancelador" | "checarPermissao"

export interface MetadadosDeRotaTimesheet {
  titulo?: string
  regras?: RegraDeRotasTimesheet[]
  modulo?: NomeModuloTimesheet
  operador?: OperadorLogico
  permissoes?: OperacaoDePermissionamento[]
}

export function verificarPermissaoDeEntrarNaRota(
  metadados: MetadadosDeRotaTimesheet,
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const {
    regras = [],
    permissoes = [],
    modulo,
    operador
  } = metadados

  const rotaPossuiRegras = regras.length > 0
  const rotaEstaPermissionada = permissoes.length > 0 && modulo && operador

  if (rotaPossuiRegras) {
    regras.forEach((regra: string) => mapGuards[regra]({ to, from, next }))
  }


  if (rotaEstaPermissionada) {
    const validacaoParaEntrarNaRota = mapGuards.checarPermissao({
      permissoes,
      permissionamento: usarPermissionamento(modulo),
      operador,
    })
    next(validacaoParaEntrarNaRota)
  } else {
    next(true)
  }
}

export async function beforeEach(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const definirTituloDaRota = () => {
    const extrairTituloDaRota = () => {
      return to.meta.titulo ? `${to.meta.titulo} - Timesheet` : "Timesheet"
    }

    window.document.title = extrairTituloDaRota()
  }

  definirTituloDaRota()

  const deveCarregarUsuarioLogado =
    SessaoServico.autenticado &&
    to.name !== "Login" &&
    !SessaoServico.coletarInformacoesDoUsuarioLogado().id
  if (deveCarregarUsuarioLogado) {
    const carregouUsuarioLogado =
      await SessaoServico.aguardarCarregamentoDoUsuarioLogado()

    if (!carregouUsuarioLogado) {
      SessaoServico.limparInformacoesDaSessao()
      next({ name: "Login" })
      return
    }
  }

  verificarPermissaoDeEntrarNaRota(
    to.meta as MetadadosDeRotaTimesheet,
    to,
    from,
    next
  )
}

router.beforeEach(beforeEach)

export { routes } // este é usado para os testes
export default router
